goog.provide("shadow.js.shim.module$react_use$lib$useMedia");
goog.provide("module$shadow_js_shim_module$react_use$lib$useMedia");
shadow.js.shim.module$react_use$lib$useMedia = shadow.js.nativeProvides["react-use/lib/useMedia"] = shadow$bridge("react-use/lib/useMedia");
module$shadow_js_shim_module$react_use$lib$useMedia.default = shadow.js.shim.module$react_use$lib$useMedia;
